import { ApplicationAction } from '@features/applications';

export const applicationActions: ApplicationAction[] = [
  {
    title: 'Message',
    message: '',
    showSendWithoutMessage: false,
    actionType: 'message',
  },
  {
    title: 'Request More Info',
    message:
      "<p>We'd love to review your application but we need a little more info. Please upload or fill out your resume information and references as soon as possible. Thank you!</p>",
    showSendWithoutMessage: false,
    actionType: 'request more info',
  },
  {
    title: 'Move to Saved',
    message:
      "<p>Thank you for your interest in joining our team! We've reviewed your application and while we'd love a chance to get to know you better, we're not currently hiring at this time. We've added you to our qualified list and will be sure to reach out to set up an interview as soon as a position becomes available.</p>",
    showSendWithoutMessage: true,
    actionType: 'save',
  },
  {
    title: 'Invite to Hireflix Interview',
    message:
      "<p>Thank you for your interest in joining our team. We've reviewed your application and would love to learn more about you.</p>\n<p>The next step is a brief <strong>pre-recorded video interview</strong> consisting of a few short questions. You can complete it on your own time — it only takes a few minutes. Please use the link provided.</p>\n<p>For best results, record your interview within the next 48 hours in a quiet space with good lighting and a stable internet connection. We recommend using Chrome on a laptop or smartphone (or Safari if you're on an iPhone).</p>\n<p>Once we've reviewed your interview, we'll reach out with next steps.</p><p>We look forward to your submission!</p>",
    showSendWithoutMessage: false,
    actionType: 'invite to hireflix interview',
  },
  {
    title: 'Invite to Interview Block',
    message:
      "<p>Thank you for your interest in joining our team! We've reviewed your application and we'd love to set up an interview. Please see our available interview times in your application and sign up for your preference, or respond directly with interview time preferences and we'll be sure to get you on the calendar.</p>",
    showSendWithoutMessage: false,
    actionType: 'invite to interview block',
  },
  {
    title: 'Invite to Open Interview',
    message:
      "<p>Thank you for your interest in joining our team! We've reviewed your application and we'd love to set up an interview. Please see our open interview times in your application and sign up for your preference, or respond directly with interview time preferences and we'll be sure to get you on the calendar.</p>",
    showSendWithoutMessage: false,
    actionType: 'Invite to Open Interview',
  },
  {
    title: 'Scheduled Interview',
    message:
      "<p>Thank you for your interest in joining our team! We've reviewed your application and we'd love to set up an interview. Please respond to our interview request to confirm the interview, or shoot us a message with interview time preferences and we'll be sure to get you on the calendar. We look forward to meeting you!</p>",
    showSendWithoutMessage: false,
    actionType: 'Scheduled Interview',
  },
  {
    title: 'Mark as Interview Completed',
    message:
      "<p>Thank you for your interest in joining our team! We've reviewed your application and we'd love to set up an interview. Please see our available interview times in your application and sign up for your time preference. We look forward to meeting you!</p>",
    showSendWithoutMessage: false,
    actionType: 'Interview Completed',
  },
  {
    title: 'Mark as Interview Missed',
    message:
      "<p>Thank you for your interest in joining our team! We've reviewed your application and we'd love to set up an interview. Please see our available interview times in your application and sign up for your time preference. We look forward to meeting you!</p>",
    showSendWithoutMessage: false,
    actionType: 'Interview Missed',
  },
  {
    title: 'Send Job Offer / Hire',
    message:
      "<p>You made the cut! We'd absolutely love for you to join our team! If you're ready to work with us, please accept our job offer, and we'll be in touch to discuss training and next steps. Congratulations and we look forward to having you on the team!</p>",
    showSendWithoutMessage: true,
    actionType: 'hire',
  },
  {
    title: 'Mark as Terminated',
    message: '',
    showSendWithoutMessage: false,
    actionType: 'terminated',
  },
  {
    title: 'Mark as Resigned',
    message: '',
    showSendWithoutMessage: false,
    actionType: 'resined',
  },
  {
    title: 'Move to Declined',
    message:
      "<p>Thank you for your interest in joining our team! We've reviewed your application and do not have a position available for you at this time. Good luck in your job search!</p>",
    showSendWithoutMessage: true,
    actionType: 'decline',
  },
  {
    title: 'Move to Archived',
    message:
      '<p>Your application has been archived due to inactivity.  If you’re still interested in the position or have updated your experience and resume, you’re welcome to reapply.  Thanks again for your interest—we appreciate you considering a role with us!</p>',
    showSendWithoutMessage: true,
    actionType: 'archive',
  },
  {
    title: 'Assign Tags',
    message: '',
    showSendWithoutMessage: true,
    actionType: 'assign Tags',
  },
];

export const assignedTags = [
  { title: 'Need Followup' },
  { title: 'No Show Interview' },
  { title: 'Great Avalibility' },
  { title: 'Can Walk Mornings' },
  { title: 'Has Refrence' },
];
